import { useNavigate } from 'react-router-dom'

import { Button, Card } from '@factorialco/deprecated-design-system'
import moment from 'moment'

import { observer } from 'mobx-react'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import { contractVersionEmployee } from 'modules/contracts/lib/contractVersionEmployee'
import { currentContractVersions } from 'modules/contracts/lib/utils'
import type { ContractVersions } from 'modules/contracts/store/collections/contractVersions'
import type { ContractVersionsPayrollPolicies } from 'modules/contracts/store/collections/contractVersionsPayrollPolicies'
import employees from 'modules/employees/store/collections/employees'
import type PayrollPolicy from 'modules/payroll_bundle/store/models/Policy'

interface Props {
  payrollPolicy: PayrollPolicy
  contractVersions: ContractVersions
  contractVersionsPayrollPolicies: ContractVersionsPayrollPolicies
}

const PayrollPolicyItem = ({
  payrollPolicy,
  contractVersions,
  contractVersionsPayrollPolicies,
}: Props) => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()

  const today = moment()
  const currentActiveContractVersions = currentContractVersions(contractVersions).filter(
    (cv) => cv.activeOn(today) && contractVersionEmployee(cv, employees)?.isTerminated === false
  )

  const policyId = payrollPolicy.attributes.id

  const policyContracts = currentActiveContractVersions.filter(
    (contract) =>
      contractVersionsPayrollPolicies.find({
        contract_version_id: contract.id,
      })?.attributes.payroll_policy_id === policyId
  )

  const policyEmployeeCount = new Set(policyContracts.map((c) => c.attributes.employee_id)).size

  const handleItemClick = () => {
    navigate(
      navigation.settings.payroll_bundle.policies.fullPath({
        policyId: Number(payrollPolicy.attributes.id),
      })
    )
  }

  return (
    <Card key={policyId}>
      <Card.Title
        action={<Button onClick={handleItemClick} type="secondary" iconName="arrow-right" />}
        size="small"
      >
        {payrollPolicy.attributes.name}
      </Card.Title>
      <Card.Description>
        {i18n.t('payroll_bundle.policy_period.settings.new_employee_count', {
          count: policyEmployeeCount,
        })}
      </Card.Description>
    </Card>
  )
}

export default observer(PayrollPolicyItem)
